module.exports = __webpack_public_path__ + "static/img/Permiso(6).7d78e5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/Permiso(6).jpg
// module id = 7E5O
// module chunks = 0